import AuthLayout from '@/layouts/auth'
import { t } from '@lingui/core/macro'
import withI18n from '@/utils/withTranslations'
import { FormEvent, ReactElement } from 'react'
import { FormForgotPassword } from '@dolfin/ui/components/forms'
import { useSupabaseClient } from '@dolfin/hooks/supabase'
import { showToastError } from '@dolfin/ui/messages'
import { useRouter } from 'next/router'
import { CardWhenMobile } from '@dolfin/ui/utils/renderers'
import { getBaseUrl } from '@dolfin/utils/environment'

const ForgotPassword = () => {
  const supabase = useSupabaseClient()
  const router = useRouter()

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const email = new FormData(e.currentTarget).get('email') as string

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: getBaseUrl() + '/reset-password'
    })

    if (error) {
      showToastError(new Error(t`Error sending reset password email`))
      return
    }

    router.push('/forgot-password/sent')
  }

  return (
    <CardWhenMobile>
      <FormForgotPassword onSubmit={handleSubmit} />
    </CardWhenMobile>
  )
}

ForgotPassword.getLayout = function getLayout(page: ReactElement) {
  return <AuthLayout>{page}</AuthLayout>
}

export const getServerSideProps = withI18n(ctx => {
  return {
    props: { translation: ctx.translation, locale: ctx.locale }
  }
})

export default ForgotPassword
